import { createAction, createSlice } from '@reduxjs/toolkit';
import { extractSharedActions, reducerUpsertHelper } from '@sda/utils/store';
import { Reducers } from '@sda/enums/store';
import { createEntityAdapter } from '@client/store/entity.adapter';
import { getDateTime } from '@sda/utils/date';
import type { PayloadAction } from '@reduxjs/toolkit';
import type { NotificationsState } from '@sda/interfaces/reducer/notifications.reducer';
import type { Notification } from '@sda/interfaces/notification';
import type { FetchDataType } from '@sda/sdk/interfaces';
import type { UpsertItem } from '@sda/utils/store/interfaces';

export const startReadThreadNotifications = createAction<string>(`${Reducers.NOTIFICATIONS}/startReadThreadNotifications`);

const initialState: NotificationsState = {
  unseenItems: null,
};

export const notificationAdapter = createEntityAdapter<Notification & FetchDataType>({
  sortComparer: (a, b) => getDateTime(b.createdAt).toMillis() - getDateTime(a.createdAt).toMillis(),
});

const notificationsSlice = createSlice({
  initialState: notificationAdapter.getInitialState<NotificationsState>(initialState),
  name: Reducers.NOTIFICATIONS,
  reducers: {
    ...extractSharedActions(notificationAdapter),
    upsertUnseenNotification: (state, action: PayloadAction<UpsertItem<Notification & FetchDataType>>) => {
      const items = reducerUpsertHelper(state.unseenItems, action.payload, 'id');

      state.unseenItems = items;
    },
  },
});

export const {
  upsertUnseenNotification, upsertMany: upsertNotifications,
} = notificationsSlice.actions;

export default notificationsSlice.reducer;
